import { useEffect, useState } from 'react'

import { useGuideContext } from 'react-provider'
import CardLayout from '@/components/CardLayout'
import DynamicItem from '@/components/DynamicItem'
import ScrollEnd from '@/components/ScrollEnd'
import { useCustomNavigate, useVisibilityReport } from '@/hooks'
import { isSuccess } from '@/axios'
import { getDiscoverThreadList, IThreadListItem } from '@/api'
import { CONTENT_VIEW_FROM_KEY, cn, handleResourceClickTrack, handleResourceDisplayTrack, setCookieAuthInfo } from '@/utils'
import SkeletonState from '@/components/CommonState/SkeletonState'

interface PropsIn {
  className?: string
}

const DiscoverDynamic = (props: PropsIn) => {
  const { className } = props
  const { customNavigator } = useCustomNavigate()
  const [data, setData] = useState<IThreadListItem[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const { reportReady } = useGuideContext()

  const getData = async () => {
    setIsLoading(true)
    const resp = await getDiscoverThreadList()
    setIsLoading(false)
    if (isSuccess(resp)) {
      return setData(resp.data.list)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        getData()
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])

  useVisibilityReport('threadList', () => {
    handleResourceDisplayTrack({
      thread_display: true,
    })
  })

  if (isLoading) {
    return (
      <CardLayout title='Thread' rootClassName={cn(className)}>
        <SkeletonState type={['threadList']} commentCount={2} className='[&>div>div]:md:flex-1 [&>div]:gap-[37px] [&>div]:md:flex' />
      </CardLayout>
    )
  }

  return (
    <>
      {data?.length ? (
        <CardLayout
          title='Thread'
          rootClassName={cn(className)}
          ref={() => {
            reportReady('dynamicBox')
          }}
          extra={
            <span
              className={cn('cursor-pointer font-geologica text-[26px] font-light text-color-white-trans70')}
              onClick={() => {
                customNavigator('/threadList')
              }}
            >
              More
            </span>
          }
        >
          <div className={cn('mx-[30px] flex flex-col items-center md:mx-0')} id='threadList'>
            <div className={cn('flex w-full flex-col md:flex-row md:gap-[30px]')}>
              {data.map((item, index) => {
                return (
                  <DynamicItem
                    data={item}
                    className={cn('w-full md:w-1/2', '[&_.picBox]:md:grid-cols-4')}
                    key={`${item.cmty_id}-${index}`}
                    afterOnClick={() => {
                      handleResourceClickTrack({
                        thread_enter: item.cmty_id,
                        resource_id: item.type === 2 ? item.resource_id : '',
                        resource_genre: item.type === 2 ? (item.resource_data?.tag_id ?? '') : '',
                        resource_tag_id: item.type === 2 ? item.resource_data?.plot_info?.map((item) => item.plot_id)?.join(',') || '' : '',
                        button: '1',
                      })
                    }}
                    onReadBefore={() => {
                      // 设置content_view埋点来源
                      setCookieAuthInfo(CONTENT_VIEW_FROM_KEY, JSON.stringify(8))
                      handleResourceClickTrack({
                        thread_enter: item.cmty_id,
                        resource_id: item.type === 2 ? item.resource_id : '',
                        resource_genre: item.type === 2 ? (item.resource_data?.tag_id ?? '') : '',
                        resource_tag_id: item.type === 2 ? item.resource_data?.plot_info?.map((item) => item.plot_id)?.join(',') || '' : '',
                        button: '2',
                      })
                    }}
                  />
                )
              })}
            </div>
            <ScrollEnd
              className={cn('mb-[47px] mt-[17px] w-auto')}
              tip={
                <div className={cn('mb-[17px] flex flex-col text-center font-geologica text-[22px] font-normal text-color-white-trans60')}>
                  <div>You’ve reached the bottom!</div>
                  <div>You’re unstoppable!</div>
                </div>
              }
            />
          </div>
        </CardLayout>
      ) : null}
    </>
  )
}

export default DiscoverDynamic
